import React, { Component } from 'react';
import {
  Container, Row, Col,
  Card, CardBody, CardTitle,
} from 'reactstrap';

import ParadigmaTable from "../../../../components/ParadigmaTable/";
import ParadigmaAsyncSeeker from '../../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker';
import ParadigmaLabeledInput from '../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput';
import api from '../../../../api/';

import ArticulosModal from "./ModalArticulo/ArticulosModal.js";
import CategoriasArticulosModal from "./CategoriasArticulosModal.js";
import ShowArticulosBtn from './ShowArticulosBtn';

import './styles.css';

class Articulos extends Component {
  constructor() {
    super();
    this.refTable = React.createRef();
    this.state = {
      columns: [
        {
          Header: "id",
          id: "id",
          accessor: "id",
          show: false,
          private: true,
        },
        {
          Header: "Categoria_id",
          id: "Categoria_id",
          accessor: "Categoria_id",
          lookup: "exact",
          show: false,
          private: true,
        },
        {
          Header: "Marca_id",
          id: "Marca_id",
          accessor: "Marca_id",
          lookup: "exact",
          show: false,
          private: true,
        },
        {
          Header: "Proveedor_id",
          id: "Proveedor_id",
          accessor: "Proveedor_id",
          lookup: "exact",
          show: false,
          private: true,
        },
        {
          Header: "Grupo_id",
          id: "Grupo_id",
          accessor: "Grupo_id",
          lookup: "exact",
          show: false,
          private: true,
        },
        {
          Header: "Rubro_id",
          id: "Rubro_id",
          accessor: "Rubro_id",
          lookup: "exact",
          show: false,
          private: true,
        },
        {
          Header: "Linea_id",
          id: "Linea_id",
          accessor: "Linea_id",
          lookup: "exact",
          show: false,
          private: true,
        },
        {
          Header: "Codigo",
          id: "Codigo",
          accessor: "Codigo",
          show: true,
          style: { textAlign: "center" },
          filterable: true,
          width: 100,
          Filter: ({ filter, onChange }) => (
            <input
              type="text"
              id="filtro-codigo"
              className="w-100"
              onChange={event => onChange(event.target.value)}
              value={filter ? filter.value : ""}
              />
          )
        },
        {
          Header: "Categoria",
          id: "categoria_nombre",
          accessor: "categoria_nombre",
          show: true,
          filterable: true,
        },
        {
          Header: "Titulo",
          id: "Titulo",
          accessor: "Titulo",
          Filter: ({ filter, onChange }) => (
            <input
              type="text"
              id="filtro-titulo"
              className="w-100"
              onChange={event => onChange(event.target.value)}
              value={filter ? filter.value : ""}
            />
          ),
          show: true,
          filterable: true,
        },
        {
          Header: "Stock Total",
          id: "stockTotal",
          accessor: "stockTotal",
          show: true,
          filterable: true,
          width: 100,
          className: "text-center",
        },
        {
          Header: "Visible",
          id: "Show",
          accessor: d => d.Show ? "SI" : "NO",
          show: true,
          filterable: true,
          lookup: "exact",
          Filter: ({ filter, onChange }) => (
            <select
              onChange={event => onChange(event.target.value)}
              style={{ width: "100%" }}
              value={filter ? filter.value : "TODOS"}>
              <option value="">TODOS</option>
              <option value={"True"}>SI</option>
              <option value={"False"}>NO</option>
            </select>
          ),
          width: 100,
          className: "text-center",
        },
        {
          Header: "De Baja",
          id: "DeBaja",
          accessor: d => d.DeBaja ? "SI" : "NO",
          show: true,
          filterable: true,
          lookup: "exact",
          width: 100,
          className: "text-center",
          Filter: ({ filter, onChange }) => (
            <select
              onChange={event => onChange(event.target.value)}
              style={{ width: "100%" }}
              value={filter ? filter.value : "TODOS"}>
              <option value="">TODOS</option>
              <option value={"True"}>SI</option>
              <option value={"False"} selected>NO</option>
            </select>
          ),
        },
      ],
      categoria_id: null,
      marca_id: null,
      proveedor_id: null,
      grupo_id: null,
      rubro_id: null,
      linea_id: null,

      multiSelect: true,
    };
  }

  render() {
    const { additionalFields, modernTheme } = this.props;
    const {
      data, pages, loading,
      rubro_id, linea_id, grupo_id,
      marca_id, proveedor_id, categoria_id,
    } = this.state;

    const outerFilter = [{ id: "DeBaja", lookup: "exact", value: "False" }];

    if (categoria_id != undefined && categoria_id != null) {
      outerFilter.push({
        id: 'Categoria_id',
        lookup: 'exact',
        value: categoria_id
      });
    }
    if (proveedor_id != undefined && proveedor_id != null) {
      outerFilter.push({
        id: 'Proveedor_id',
        lookup: 'exact',
        value: proveedor_id
      });
    }
    if (marca_id != undefined && marca_id != null) {
      outerFilter.push({
        id: 'Marca_id',
        lookup: 'exact',
        value: marca_id
      });
    }
    if (linea_id != undefined && linea_id != null) {
      outerFilter.push({
        id: 'Linea_id',
        lookup: 'exact',
        value: linea_id
      });
    }
    if (rubro_id != undefined && rubro_id != null) {
      outerFilter.push({
        id: 'Rubro_id',
        lookup: 'exact',
        value: rubro_id
      });
    }
    if (grupo_id != undefined && grupo_id != null) {
      outerFilter.push({
        id: 'Grupo_id',
        lookup: 'exact',
        value: grupo_id
      });
    }

    return (
      <Container fluid className="p-0 container-fluid-modif container-articulos">
        <Row className="mb-2">
          <Col className="col-12">
            <Card body className="border-0 p-0 m-0">
              <CardTitle className="text-center py-2 mb-0 col-color">Filtros</CardTitle>
              <CardBody>
                <Row>
                  <Col xs={12} md={6}>
                    <ParadigmaLabeledInput
                      label="Categoria"
                      md={[2, 10]}
                      inputComponent={
                        <ParadigmaAsyncSeeker
                          url={api.gestion.articulos.categorias}
                          value={categoria_id}
                          displayField="fullName"
                          valueField="id"
                          parameters={{
                            paginationEnabled: false, sort: ["Nombre"], fields: ["id", "fullName"]
                          }}
                          onChange={data => this.setState({ categoria_id: data ? data.id : null })}
                        />
                      }
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <ParadigmaLabeledInput
                      label="Grupos"
                      md={[2, 10]}
                      inputComponent={
                        <ParadigmaAsyncSeeker
                          url={api.gestion.articulos.grupos}
                          value={grupo_id}
                          displayField="Nombre"
                          valueField="Codigo"
                          parameters={{
                            paginationEnabled: false, sort: ["Nombre"], fields: ["Codigo", "Nombre"]
                          }}
                          onChange={data => this.setState({ grupo_id: data ? data.Codigo : null })}
                        />
                      }
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={6}>
                    <ParadigmaLabeledInput
                      label="Marcas"
                      md={[2, 10]}
                      inputComponent={
                        <ParadigmaAsyncSeeker
                          url={api.gestion.articulos.marcas}
                          value={marca_id}
                          displayField="Nombre"
                          valueField="Codigo"
                          parameters={{
                            paginationEnabled: false, sort: ["Nombre"], fields: ["Codigo", "Nombre"]
                          }}
                          onChange={data => this.setState({ marca_id: data ? data.Codigo : null })}
                        />
                      }
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <ParadigmaLabeledInput
                      label="Rubros"
                      md={[2, 10]}
                      inputComponent={
                        <ParadigmaAsyncSeeker
                          url={api.gestion.articulos.rubros}
                          value={rubro_id}
                          displayField="Nombre"
                          valueField="Codigo"
                          parameters={{
                            paginationEnabled: false, sort: ["Nombre"], fields: ["Codigo", "Nombre"]
                          }}
                          onChange={data => this.setState({ rubro_id: data ? data.Codigo : null })}
                        />
                      }
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs={12} md={6}>
                    <ParadigmaLabeledInput
                      label="Proveedores"
                      md={[2, 10]}
                      inputComponent={
                        <ParadigmaAsyncSeeker
                          url={api.gestion.articulos.proveedores}
                          value={proveedor_id}
                          displayField="Nombre"
                          valueField="Codigo"
                          parameters={{
                            paginationEnabled: false, sort: ["Nombre"], fields: ["Codigo", "Nombre"]
                          }}
                          onChange={data => this.setState({ proveedor_id: data ? data.Codigo : null })}
                        />
                      }
                    />
                  </Col>
                  <Col xs={12} md={6}>
                    <ParadigmaLabeledInput
                      label="Lineas"
                      md={[2, 10]}
                      inputComponent={
                        <ParadigmaAsyncSeeker
                          url={api.gestion.articulos.lineas}
                          value={linea_id}
                          displayField="Nombre"
                          valueField="Codigo"
                          parameters={{
                            paginationEnabled: false, sort: ["Nombre"], fields: ["Codigo", "Nombre"]
                          }}
                          onChange={data => this.setState({ linea_id: data ? data.Codigo : null })}
                        />
                      }
                    />
                  </Col>
                </Row>

              </CardBody>
            </Card>
          </Col>
        </Row>
        <ParadigmaTable
          modernTheme={modernTheme}
          buttons={[
            {
              edit: true,
              component: (props) => <ArticulosModal {...props} action="DETAIL" />,
              permission: "ecommerce_articulos_articulos_detail",
            },
            {
              edit: true,
              component: (props) => <ArticulosModal {...props} action="EDIT" />,
              permission: "ecommerce_articulos_articulos_edit",
            },
            {
              edit: true,
              component: (props) => <ArticulosModal {...props} action="IMAGES" activeTab="2" />,
              permission: "ecommerce_articulos_articulos_edit",
            },
            {
              edit: true,
              component: (props) => <ArticulosModal {...props} action="PROPERTIES" activeTab="3" />,
              permission: "ecommerce_articulos_articulos_edit",
            },
            {
              edit: true,
              component: (props) => <ArticulosModal {...props} action="RELACIONADOS" activeTab="4" />,
              permission: "ecommerce_articulos_articulos_edit",
            },
            {
              createmultiSelect: true,
              component: (props) => (
                <CategoriasArticulosModal
                {...props}
                action="EDIT"
                filters={{
                  rubro_id, linea_id, grupo_id,
                  marca_id, proveedor_id, categoria_id,
                  tituloInputNode: document.getElementById("filtro-titulo"),
                  codigoInputNode: document.getElementById("filtro-codigo"),
                  somethingSelected: rubro_id || linea_id || grupo_id || marca_id || proveedor_id || categoria_id || (document.getElementById("filtro-codigo") && document.getElementById("filtro-codigo").value != "") || (document.getElementById("filtro-titulo") && document.getElementById("filtro-titulo").value != "")
                }}
                />
              ),
              permission: "ecommerce_articulos_articulos_edit",
            },
            {
              permission: "ecommerce_articulos_articulos_edit",
              customComponent: true,
              multiSelect: true,
              component: (props) => (
                <ShowArticulosBtn
                {...props}
                action="MOSTRAR"
                filters={{
                  rubro_id, linea_id, grupo_id,
                  marca_id, proveedor_id, categoria_id,
                  tituloInputNode: document.getElementById("filtro-titulo"),
                  codigoInputNode: document.getElementById("filtro-codigo"),
                  somethingSelected: rubro_id || linea_id || grupo_id || marca_id || proveedor_id || categoria_id || (document.getElementById("filtro-codigo") && document.getElementById("filtro-codigo").value != "") || (document.getElementById("filtro-titulo") && document.getElementById("filtro-titulo").value != "")
                }}
                />
              ),
            },
            {
              permission: "ecommerce_articulos_articulos_edit",
              customComponent: true,
              multiSelect: true,
              component: (props) => (
                <ShowArticulosBtn
                {...props}
                action="OCULTAR"
                filters={{
                  rubro_id, linea_id, grupo_id,
                  marca_id, proveedor_id, categoria_id,
                  tituloInputNode: document.getElementById("filtro-titulo"),
                  codigoInputNode: document.getElementById("filtro-codigo"),
                  somethingSelected: rubro_id || linea_id || grupo_id || marca_id || proveedor_id || categoria_id || (document.getElementById("filtro-codigo") && document.getElementById("filtro-codigo").value != "") || (document.getElementById("filtro-titulo") && document.getElementById("filtro-titulo").value != "")
                }}
                />
              ),
            },
          ]}
          apiUrl={api.gestion.articulos.articulos}
          columns={this.state.columns}
          title={"Artículos"}
          multiSelect={this.state.multiSelect}
          ctrlKeyMultiSelect={true}
          ref={this.refTable}
          innerRef={this.refTable}
          outerFilter={[...outerFilter,]}
        />

      </Container>
    );
  }
}

export default Articulos;



// WEBPACK FOOTER //
// ./src/views/Gestion/Articulos/Articulos/Articulos.js